var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-col',{staticClass:"modal-message"},[_c('van-overlay',{attrs:{"show":_vm.isShow}},[(_vm.type==='loading')?_c('van-col',{staticClass:"message-loading"},[_c('van-loading',{attrs:{"size":"48px","vertical":""}},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }